<template>
  <div>
    <div class="main-wrap">
      <app-bar dense invert class="border-bottom" />
      <div class="container-wrap">
        <div class="space-top space-bottom">
          <slot>
            <!-- <section class="space-top space-bottom" v-for="i in 5" :key="i">
            <h2 class="display-3 text-center mb-4">
              <span v-t="'A simple example'" />
            </h2>
            <h4 class="display-1 text-center">
              <span v-t="'It's a blank-page. Start to build your'e page from here.'" />
            </h4>
          </section> -->
          </slot>
        </div>
      </div>
      <section id="footer">
        <main-footer />
      </section>

      <hidden point="mdDown">
        <!-- <PageNav /> -->
      </hidden>
      <hidden point="mdDown">
        <!-- <notification /> -->
      </hidden>
    </div>
    <!-- <section id="home" /> -->
    <!-- <div class="main-wrap">
      <app-bar class="header-background" dense />
      <div class="container-wrap">
        <section class="space-top space-bottom" v-for="i in 5" :key="i">
          <h2 class="display-3 text-center mb-4">
            <span v-t="'A simple example'" />
          </h2>
          <h4 class="display-1 text-center">
            <span v-t="'It's a blank-page. Start to build your'e page from here.'" />
          </h4>
        </section>
      </div>
      <section class="spaceTop">
        <main-footer invert><div></div></main-footer>
      </section>
      <notification />
    </div> -->
  </div>
</template>

<style scoped lang="scss">
@import "@/landing/dependencies.scss";

@function section-margin($margin) {
  @return $margin * 20;
}
.main-wrap {
  position: relative;
  width: 100%;
  overflow: hidden;
  @include palette-text-primary;
  .theme--dark & {
    background-color: $dark-background-default;
  }
  .theme--light & {
    background-color: $light-background-paper;
  }
}
.space-bottom {
  margin-bottom: section-margin($spacing1);
}
.space-top {
  margin-top: section-margin($spacing1);
}
.container-wrap {
  //   margin-top: $spacing10;
  //   padding: $spacing4;
  > section {
    position: relative;
  }
}
</style>

<script>
import AppBar from "@/landing/components/Header/AppBar";
import MainFooter from "@/landing/components/Footer/FooterWithBackground";
import Notification from "@/landing/components/Notification";
import Banner from "@/landing/components/Banner/SmallBanner";
import brand from "@/landing/static/text/brand";

export default {
  components: {
    AppBar,
    Notification,
    Banner,
    MainFooter,
  },
  head() {
    return {
      title: brand.name + " - Blank Page",
    };
  },
};
</script>

<style scoped lang="scss">
.container-wrap {
  min-height: calc(100vh - 72px - 160px);
}
</style>
